<template>
  <div class="container-fluid mt-2">
    <vs-card>
      <div slot="header">
        Seguridad en el API
        <vs-switch class="float-right" v-model="apiSecurityState" @click="saveConfig()"></vs-switch>
      </div>

      <strong>Host: https://www.redgirasol.com/api</strong>

      <div class="flex">
        <vs-alert color="warning" v-if="newRoutes.length > 0 || removedRoutes.length > 0">
          <a href="#" @click="openDialogNewRoutes()">
            Se han detectado {{newRoutes.length}} rutas nuevas y {{removedRoutes.length}} para eliminar
          </a>
        </vs-alert>
      </div>

      <div class="row flex">
        <card-result
          class="flex-1 m-5 cursor-pointer"
          icon="LinkIcon"
          @click="changeFilter('')"
          icon-right
          statistic="Rutas"
          color="danger"
          :text="permissions.length.toString()"
          :hide-chart="true"/>

        <card-result
          class="flex-1 m-5 cursor-pointer"
          icon="UnlockIcon"
          icon-right
          statistic="Sin Auth"
          @click="changeFilter('routes_without_auth')"
          color="danger"
          :text="routes_without_auth.length.toString()"
          :hide-chart="true"/>

        <card-result
          class="flex-1 m-5 cursor-pointer"
          icon="UnlockIcon"
          icon-right
          statistic="Sin Rol"
          @click="changeFilter('routes_without_roles')"
          color="danger"
          :text="routes_without_roles.length.toString()"
          :hide-chart="true"/>


        <card-result
          class="flex-1 m-5 cursor-pointer"
          icon="UnlockIcon"
          icon-right
          statistic="Sin Responsable"
          @click="changeFilter('routes_without_responsible')"
          color="danger"
          :text="routes_without_responsible.length.toString()"
          :hide-chart="true"/>

        <card-result
          class="flex-1 m-5 cursor-pointer"
          icon="UnlockIcon"
          icon-right
          statistic="Sin Uso"
          @click="changeFilter('routes_unused')"
          color="danger"
          :text="routes_unused.length.toString()"
          :hide-chart="true"/>
      </div>

      <div class="row flex">
        <div class="flex-1">
          <vs-select v-model="responsible_user_id_filtered" label="Filtro por responsable" class="ml-6">
            <vs-select-item
              v-for="developer in developers"
              :value="developer.id"
              :key="developer.id"
              :text="([developer.first_name, developer.last_name_1].join(' ') )" />
          </vs-select>
        </div>
        <div class="flex-1">
          <vs-button @click="purgeCache()" color="warning" class="float-right medium mr-6 mb-6">Purgar cache</vs-button>
        </div>
      </div>

      <vs-table stripe :data="permissions" >
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Metodo Http</vs-th>
          <vs-th>Servicio</vs-th>
          <vs-th>Ruta</vs-th>
          <vs-th>Middleware</vs-th>
          <vs-th>Responsable</vs-th>
          <vs-th>Roles</vs-th>
          <vs-th>Marcar para eliminar</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="permission in dynamicFilter(permissionFilter)" :key="permission.id">
            <vs-td>{{permission.id}}</vs-td>
            <vs-td>
              <span :class="`http-verb ${permission.method.toLowerCase()}`">{{permission.method}}</span>
            </vs-td>
            <vs-td>
              <a href="#" @click="openDialogService(permission)">
                <span v-if="permission.service">
                  {{permission.service.name}}
                </span>
                <span v-else>Sin asignar</span>
              </a>
            </vs-td>
            <vs-td :class="{'route-as-remove': permission.mark_as_delete}">
              {{permission.uri}}
              <em class="fas fa-check-double" v-if="permission.used"></em>
            </vs-td>
            <vs-td>{{permission.middleware.join(", ")}}</vs-td>
            <vs-td>
              <a href="#" @click="openDialogResponsible(permission)">
                <span v-if="!permission.responsible">Sin asignar</span>
                <span v-else>{{permission.responsible.email}}</span>
              </a>
            </vs-td>
            <vs-td>
              <a @click="openRoleDialog(permission)" href="#">
                <span v-if="permission.roles.length === 0">Sin asignar</span>
                <span v-else>{{permission.roles.map(item => item.name).join(", ")}}</span>
              </a>
            </vs-td>
            <vs-td>
              <vs-button color="danger" v-if="!permission.mark_as_delete" @click="markAsDelete(permission)">
                <em class="far fa-check-square"></em>
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <vs-popup title="Nuevas Rutas" :active.sync="newRoutesDialogOpened">
        <vs-list>
          <vs-list-item v-for="newRoute in newRoutes" :key="newRoute.id" class="ml-0">
            <span :class="`http-verb ${newRoute.method.toLowerCase()}`"><strong>{{newRoute.method}}</strong></span> {{newRoute.uri}}
          </vs-list-item>
          <vs-list-item v-for="removeRoute in removedRoutes" :key="removeRoute.id" class="text-left">
            <div class="route-for-remove">
              <span :class="`http-verb ${removeRoute.method.toLowerCase()}`"><strong>{{removeRoute.method}}</strong></span> {{removeRoute.uri}}
            </div>
          </vs-list-item>
        </vs-list>

      <div class="mt-6">
        <vs-button @click="syncRoutes()">Sincronizar</vs-button>
      </div>
    </vs-popup>




    <vs-popup :active.sync="roleDialogOpened" title="Asignar roles">
      <vs-input class="w-full" v-model="selection.route.uri" disabled label="Uri"></vs-input>
        <vs-list>
          <vs-list-item v-for="role in roles" :key="role.id">
            <vs-checkbox v-model="selection.roles" :value="role.id" />
            <div class="md-list-item-text">
              <span>{{role.name}}</span>
              <span>
                <strong>{{role.guard_name}}</strong>
              </span>
            </div>
          </vs-list-item>
        </vs-list>

      <div class="mt-6">
        <vs-button @click="savePermissions()">Guardar cambios</vs-button>
      </div>
    </vs-popup>



    <vs-popup :active.sync="responsibleDialogOpened" title="Asignar Responsable">
      <vs-input class="w-full" v-model="selection.route.uri" disabled label="URI"></vs-input>
      <vs-select
          class="w-full"
          v-model="selection.responsible"
          title="Responsable">
        <vs-select-item
            :text="[developer.first_name, developer.last_name_1].join(' ')"
            v-for="developer in developers"
            :value="developer.id"
            :key="developer.id">
        </vs-select-item>
      </vs-select>

      <div class="mt-6">
        <vs-button @click="saveResponsible()">Guardar cambios</vs-button>
      </div>
    </vs-popup>


    <vs-popup :active.sync="openDialogServiceOpened" title="Asignar Servicio">
        <vs-input label="URI" v-model="selection.route.uri" disabled></vs-input>
        <vs-select v-model="selection.service" label="Servicios">
          <vs-select-item v-for="service in services" :value="service.id" :key="service.id" :text="service.service">
            {{service.service}}
          </vs-select-item>
        </vs-select>
      <div class="mt-6">
        <vs-button @click="saveService()">Guardar cambios</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import CardResult from "@views/admin/admon/Refund/CardResult";

export default {
  name: "ApiSecurity",
  components: {CardResult},
  data: () => ({
    roleDialogOpened: false,
    newRoutesDialogOpened: false,
    responsibleDialogOpened: false,
    openDialogServiceOpened: false,
    apiSecurityState: false,
    permissionFilter: '',
    permissions: [],
    allPermissions: [],
    responsible_user_id_filtered: '',
    roles: [],
    developers: [],
    newRoutes: [],
    removedRoutes: [],
    services: [],
    selection: {
      service: null,
      responsible:{},
      route: { id: null, uri: ''},
      roles: []
    }
  }),
  watch: {
    responsible_user_id_filtered: function (value) {
      this.changeFilter('filter_by_assignable')
    }
  },
  computed: {
    routes_unused() {
      return this.permissions.filter((route) => route.used === 0);
    },
    routes_without_auth() {
      return this.permissions.filter((route) => !this.has(route.middleware, "auth:api"))
    },
    routes_without_roles() {
      return this.permissions.filter((route) => route.roles.length === 0)
    },
    routes_without_responsible() {
      return this.permissions.filter((route) => route.responsible === null)
    }
  },
  async mounted() {
    await this.checkIfHaveNewRoutes();

    let configResponse = await axios.get(`/api/api-security/route-permissions/config`);
    this.apiSecurityState = configResponse.data.is_active;

    let servicesResponse = await axios.get(`/api/api-security/route-permissions/services`);
    this.services = servicesResponse.data;

    let roleResponse = await axios.get(`/api/roles`)
    this.roles = roleResponse.data

    let rgDevelopers = await axios.get(`/api/user?role=dev`)
    this.developers = rgDevelopers.data;

    await this.main();
  },
  methods: {
    async markAsDelete(route) {
      if(confirm("¿Estas seguro de marcar para eliminación?")) {
        try {
          await axios.put(`/api/api-security/route-permissions/${route.id}/mark-as-delete`)
          route.mark_as_delete = 1;
        } catch (e) {
          throw e;
        }
      }
    },
    dynamicFilter(permissionFilter, email) {
      switch (permissionFilter) {
        case 'routes_without_auth':
          return this.routes_without_auth;
        case 'routes_without_roles':
          return this.routes_without_roles;
        case 'routes_without_responsible':
          return this.routes_without_responsible;
        case 'routes_unused':
          return this.routes_unused;
        case 'filter_by_assignable':
          return this.filterByAssignable(this.responsible_user_id_filtered);
        default:
          return this.permissions;
      }
    },

    filterByAssignable(responsible_user_id_filtered) {
      return this.permissions.filter((route) => route.responsible !== null)
        .filter((route) => route.responsible.id === responsible_user_id_filtered)
    },
    changeFilter(filter) {
      this.permissionFilter = filter;
    },
    async saveConfig() {
      let configResponse = await axios.put(`/api/api-security/route-permissions/turn-on-off`, {
        api_security_active: !this.apiSecurityState
      });

      this.apiSecurityState = configResponse.data.is_active
    },
    async checkIfHaveNewRoutes() {
      let routesComparative = await axios.get(`/api/api-security/route-permissions/route-changes-detection`)
      this.newRoutes = routesComparative.data.new_routes;
      this.removedRoutes = routesComparative.data.remove_routes;
    },
    async main() {
      let permissionResponse = await axios.get(`/api/api-security/route-permissions`);
      this.permissions = permissionResponse.data;
    },
    has(array, key) {
      let matches = array.filter((item) => item === key).length;
      return matches > 0;
    },
    hasRegex(array, regex) {
      let matches = array.filter((item) => item !== regex).length;
      return matches > 0;
    },
    openRoleDialog(permission) {
      this.selection.route = permission;
      this.roleDialogOpened = true;
    },
    openDialogResponsible (permission) {
      this.selection.route = permission;
      this.responsibleDialogOpened = true;
    },
    async savePermissions() {
      let permissionResponse = await axios.put(`/api/api-security/route-permissions/${this.selection.route.id}/roles`, {
        roles: this.selection.roles
      });

      this.roleDialogOpened = false;
      await this.main();
    },
    async saveResponsible() {
      let responsibleResponse = await axios.put(`/api/api-security/route-permissions/${this.selection.route.id}/add-responsible`, {
        user_id: this.selection.responsible
      });

      this.responsibleDialogOpened = false;
      await this.main();
    },
    async saveService() {
      let responsibleResponse = await axios.put(`/api/api-security/route-permissions/${this.selection.route.id}/add-service`, {
        application_service_id: this.selection.service
      });

      this.openDialogServiceOpened = false;
      await this.main();
    },
    openDialogService(permission) {
      this.selection.route = permission;
      this.openDialogServiceOpened = true;
    },
    openDialogNewRoutes() {
      this.newRoutesDialogOpened = true;
    },
    async syncRoutes() {
       await axios.post(`/api/api-security/route-permissions/route/sync`, {
        user_id: this.selection.responsible
      });

       this.newRoutesDialogOpened = false;
       await this.main();
       await this.checkIfHaveNewRoutes();
    },
    async purgeCache() {
      await axios.post(`/api/api-security/route-permissions/purge-cache`, {
        user_id: this.selection.responsible
      });
    }
  }
}
</script>

<style scoped>
.vs-table--td {
  font-size: 12px;
}
.http-verb {
  color: white;
  padding: 2px;
}
.http-verb.get {
  background: green;
}
.http-verb.post {
  background: blue;
}
.http-verb.put {
  background: purple;
}
.http-verb.delete {
  background: red;
}
.md-menu-content.md-select-menu {
  z-index: 1001;
}
.route-as-remove {
  text-decoration-line: line-through;
}

</style>
<style>
.vs-list--slot {
  margin-left: 0px !important;
}
</style>
